import script from "./DeficienciaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DeficienciaForm.vue?vue&type=script&setup=true&lang=js"

import "./DeficienciaForm.vue?vue&type=style&index=0&id=29a8d8d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a8d8d2"]])

export default __exports__